import type {
  ComboboxContextValue,
  ComboboxOptionBase,
} from '@/components/Combobox/types';
import { createContext } from 'react';

export const ComboboxContext =
  createContext<ComboboxContextValue<ComboboxOptionBase> | null>(null);
